import React, { useMemo } from "react";

import { Executor } from "../../../../../../../../../../services";
import { useAppContext } from "../../../../../../../../../../context";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

const RegisteredAtCellContent: React.FC<RegisteredAtCellContent.Props> = ({
	item,
}) => {
	const { dateFns } = useAppContext();

	const content = useMemo(
		() =>
			item.createdAt
				? dateFns.formatTime2(item.createdAt, "dd.MM.yyyy")
				: "",
		[dateFns, item.createdAt],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace RegisteredAtCellContent {
	interface Props {
		item: Executor.Model;
	}
}

export default RegisteredAtCellContent;
